import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function GoogleAllowlistCard() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", role: "agent" });
  const load = () => api.get("/users/google-allowlist").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/users/google-allowlist", form); toast.success("Email autorisé"); setForm({ email: "", name: "", role: "agent" }); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Ajout impossible"); }
  };
  const remove = async (email) => {
    try { await api.delete(`/users/google-allowlist/${encodeURIComponent(email)}`); load(); } catch { toast.error("Suppression impossible"); }
  };
  return (
    <div className="card-flat p-5 mt-6" data-testid="google-allowlist-card">
      <h3 className="font-heading text-lg font-medium text-norea-text">Emails autorisés — connexion Google</h3>
      <p className="text-xs text-norea-textMuted mt-1 mb-4 max-w-3xl">Les utilisateurs ci-dessus peuvent déjà se connecter avec Google (même email), avec leur rôle. Ajoutez ici une personne sans compte : son compte sera créé avec le rôle choisi à sa première connexion Google. Tout autre compte Google est refusé.</p>
      <form onSubmit={add} className="flex flex-wrap gap-2 mb-4">
        <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="prenom.nom@gmail.com" className="input-field flex-1 min-w-[220px]" data-testid="allowlist-email-input" />
        <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nom (facultatif)" className="input-field w-48" data-testid="allowlist-name-input" />
        <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="input-field w-36" data-testid="allowlist-role-select">
          <option value="agent">Agent</option><option value="admin">Administrateur</option>
        </select>
        <button type="submit" className="btn-primary" data-testid="allowlist-add-btn"><Plus className="w-4 h-4" /> Autoriser</button>
      </form>
      {items.length === 0 ? <div className="text-sm text-norea-textMuted" data-testid="allowlist-empty">Aucun email en attente.</div> : (
        <div className="divide-y divide-norea-border border border-norea-border rounded-md">
          {items.map((a) => (
            <div key={a.email} className="flex items-center gap-3 px-3 py-2 text-sm" data-testid={`allowlist-row-${a.email}`}>
              <span className="flex-1 font-mono text-xs">{a.email}</span>
              <span className="text-norea-textMuted">{a.name}</span>
              <span className="text-xs px-2 py-0.5 rounded bg-norea-surfaceHover">{a.role === "admin" ? "Administrateur" : "Agent"}</span>
              <span className="text-xs text-norea-textMuted w-40">{a.used_at ? `Compte créé le ${new Date(a.used_at).toLocaleDateString("fr-FR")}` : "Jamais connecté"}</span>
              <button onClick={() => remove(a.email)} className="p-1.5 text-norea-textMuted hover:text-status-erreurText" aria-label="Retirer" data-testid={`allowlist-remove-${a.email}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
